import { isPageUrl } from "./../url/is-page-url.js";
const isPageLink = (link) => typeof link.url === "string" && isPageUrl(link?.url);
export {
  isPageLink
};
//# sourceMappingURL=is-page-link.js.map
